(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initSlider = (slider) => {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';
    const slides = [...slider.querySelectorAll('[data-wzp-slide]')];
    const dots = [...slider.querySelectorAll('[data-wzp-dot]')];
    const controls = slider.querySelector('[data-wzp-controls]');
    const pause = slider.querySelector('[data-wzp-pause]');
    const track = slider.querySelector('.wzp-hero__track');
    let index = 0;
    let timer;
    let paused = reducedMotion.matches || slider.dataset.autoplay !== 'true';
    let touch;
    if (controls) controls.hidden = false;

    const stop = () => window.clearInterval(timer);
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        slide.inert = i !== index;
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', String(i === index));
      });
    };
    const updatePause = () => {
      if (!pause) return;
      const label = paused ? 'Play slideshow' : 'Pause slideshow';
      pause.setAttribute('aria-label', label);
      pause.title = label;
      pause.querySelector('[data-wzp-pause-icon]').hidden = paused;
      pause.querySelector('[data-wzp-play-icon]').hidden = !paused;
      track.setAttribute('aria-live', paused ? 'polite' : 'off');
    };
    const start = () => {
      stop();
      if (!paused && !document.hidden && !slider.contains(document.activeElement) && slides.length > 1) {
        timer = window.setInterval(() => show(index + 1), 8000);
      }
    };
    const manualShow = (next) => {
      paused = true;
      stop();
      updatePause();
      show(next);
    };
    slider.querySelector('[data-wzp-prev]')?.addEventListener('click', () => manualShow(index - 1));
    slider.querySelector('[data-wzp-next]')?.addEventListener('click', () => manualShow(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => manualShow(i)));
    pause?.addEventListener('click', () => { paused = !paused; updatePause(); start(); });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', () => window.setTimeout(start, 0));
    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        manualShow(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    slider.addEventListener('touchstart', (event) => {
      touch = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      stop();
    }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      if (!touch) return;
      const dx = event.changedTouches[0].clientX - touch.x;
      const dy = event.changedTouches[0].clientY - touch.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) manualShow(index + (dx < 0 ? 1 : -1));
      touch = null;
    }, { passive: true });
    const onVisibility = () => document.hidden ? stop() : start();
    const onMotionChange = () => { if (reducedMotion.matches) { paused = true; stop(); updatePause(); } };
    document.addEventListener('visibilitychange', onVisibility);
    reducedMotion.addEventListener('change', onMotionChange);
    slider.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      reducedMotion.removeEventListener('change', onMotionChange);
    });
    slider.addEventListener('shopify:block:select', (event) => {
      const i = slides.findIndex((slide) => slide.contains(event.target));
      if (i >= 0) manualShow(i);
    });
    updatePause();
    start();
  };
  document.querySelectorAll('[data-wzp-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-wzp-slider]').forEach(initSlider));

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-wzp-cart-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const label = button.querySelector('[data-wzp-button-label]');
    const status = form.querySelector('[data-wzp-cart-status]');
    const originalLabel = label.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding to cart...';
    status.textContent = '';
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'We could not add this item. Please try again.');
      window.location.assign(window.routes.cart_url);
    } catch (error) {
      status.textContent = error.message || 'Please check your connection and try again.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = originalLabel;
    }
  });
})();
